/**
 * p05001内で共通に使う変数（画面間で使用する変数）を定義する
 * 【注意】画面内（同一名のvueとts）で使用する変数は各ts内に定義すること
 */

import * as GVar from '@/components/00/Var00'; // 共通変数

//-----------------------------------------------------------------
// 変数定義
//-----------------------------------------------------------------

// 店舗検索結果一時退避変数
export let c050010Keep: any = null; // c050010のパラメータを保存
export function setC050010Keep(val: any) { c050010Keep = val; }
export let c050010KeepIdx = -1; // c050010のResultsの選択されているインデックスを保存
export function setC050010KeepIdx(val: number) { c050010KeepIdx = val; }

// 店舗感染対策状況一時退避変数
export let c050030Keep: any = null; // c050030のパラメータを保存
export function setC050030Keep(val: any) { c050030Keep = val; }

// 店舗感染対策状況サマリー一時退避変数
export let c050040Keep: any = null; // c050040のパラメータを保存
export function setC050040Keep(val: any) { c050040Keep = val; }
export let c050040KeepIdx = -1; // c050040のResult内Mpt154の選択されているインデックスを保存
export function setC050040KeepIdx(val: number) { c050040KeepIdx = val; }

// 店舗一覧一時退避変数
export let c050070Keep: any = null; // c050070のパラメータを保存
export function setC050070Keep(val: any) { c050070Keep = val; }
export let c050070KeepIdx = -1; // c050070のresults内Mpt151の選択されているインデックスを保存
export function setC050070KeepIdx(val: number) { c050070KeepIdx = val; }

// ポイント残高一時退避変数
export let c050120Keep: any = null; // c050120のパラメータを保存
export function setC050120Keep(val: any) { c050120Keep = val; }

export let pCurShpGrpId = 0;       // 選択中の店舗グループID
export function setPCurShpGrpId(val: number) { pCurShpGrpId = val; }

export let pCurShpId = 0;       // 選択中の店舗ID
export function setPCurShpId(val: number) { pCurShpId = val; }

export let s05001001_shpNm = ""; // 店舗検索用店舗名退避
export function setS05001001_shpNm(val: string) { s05001001_shpNm = val; }

export let s05001012_loaded = false;  // 会員登録済み店舗リストの２重ロード防止用 true - ロード済み、 false - 未ロード
export function setS05001012_loaded(val: boolean) { s05001012_loaded = val; }

// お店ホームページ画面用(s05001003)
// export let s05001003_refreshKey = 0;
// export function addS05001003_refreshKey() { s05001003_refreshKey++; }

// 飲食店検索ページ画面用(05001001)
export let s05001001_refresh = true;   // 飲食店検索ページ表示時の書き直し
export function setS05001001_refresh(val: boolean) { s05001001_refresh = val; }

// ポイント利用ページ(S05001014)
export let s05001014_usePoints = 0;     // 利用ポイント
export function setS05001014_usePoints(val: number) { s05001014_usePoints = val; }

// チャット用クラス

// チャットの内容
export class ChatContent
{
  id = "";        // 自動採番されたドキュメントID
  msg = "";       // メッセージ
  uid = 0;        // 書き込みユーザーID
  shpid = 0;      // 店舗ID
  who = "";       // 書き込み者 "S":店舗、"C":顧客
  created = Date(); // 書き込み日時
  readFlag = "0"; // 既読フラグ "0":未読、"1":既読
  deleted = null; // 削除日時
  constructor(id: string, doc: any)
  {
      this.id = id;      
      this.msg = String(doc.msg);
      this.uid = doc.uid;
      this.shpid = doc.shpid;
      this.who = doc.who;
      this.created = doc.created;
      this.readFlag = doc.readFlag;
      this.deleted = doc.deleted;
  }
}

// Firebase定義(Firestore, Webプッシュ)
// export const firebaseConfig = {
//   apiKey: "AIzaSyBgtHwGeWJbJ3Cd4J4uIuPR6M6ZXHSDYgE",
//   authDomain: "p05001.firebaseapp.com",
//   projectId: "p05001",
//   storageBucket: "p05001.firebasestorage.app",
//   messagingSenderId: "53467464370",
//   appId: "1:53467464370:web:5e5c7ff4599c7a9fa9ffab",
//   measurementId: "G-V9NTQFP9CK"
// };

export const firebaseConfig = {
  apiKey: "AIzaSyCZkmCbKmYD7CsiB0u5xmMh5b6Fm14amxE",
  authDomain: "p05002.firebaseapp.com",
  projectId: "p05002",
  storageBucket: "p05002.firebasestorage.app",
  messagingSenderId: "799913201952",
  appId: "1:799913201952:web:f897607289b1c74eb34745",
  measurementId: "G-HG1KZ5GR9R"
};


//-----------------------------------------------------------------
//  変数初期化関数定義
//-----------------------------------------------------------------
/**
 * アプリ固有グローバル変数の再初期化
 * ユーザーが変わった時に呼ばれる
 */
export function reInitLocalVars()
{
    // 共通変数の初期化
    GVar.reInitVars();
    c050010Keep = null; // c050010のパラメータを保存
    c050010KeepIdx = -1; // c050010のResultsの選択されているインデックスを保存
    c050030Keep = null; // c050030のパラメータを保存
    c050040Keep = null; // c050040のパラメータを保存
    c050040KeepIdx = -1; // c050040のResult内Mpt154の選択されているインデックスを保存
    s05001001_shpNm = "";   // 画面リロード時に検索用店舗名をクリアする
    pCurShpGrpId = 0;       // 選択中の店舗グループID
    pCurShpId = 0;       // 選択中の店舗ID
}